import React from "react"
import { Card, Table, TableColumnsType } from "antd"
import { IMovementRS } from "../../models/storageModel"

export interface MovementDetailNotesCardProps {
  notes: Partial<IMovementRS>[]
  columnsNotes: TableColumnsType
}

const MovementDetailNotesCard: React.FC<MovementDetailNotesCardProps> = ({
  notes,
  columnsNotes,
}) => {
  if (!notes || notes.length === 0) return null

  return (
    <Card title="Notas de Crédito / Débito relacionadas" style={{ marginTop: 24 }} className="card-shadow">
      <Table 
        columns={columnsNotes} 
        dataSource={notes} 
        pagination={false} 
        size="small"
        rowKey="id"
        scroll={{ x: 600 }}
      />
    </Card>
  )
}

export default MovementDetailNotesCard
